import { useAppSelector } from '@/store/store-hooks'
import { selectProcessingFileIds, selectUploadDrawerFileIds } from '../store/selectors'
import { ProcessingStatusItem } from './ProcessingStatusItem'

type ProcessingStatusListProps = {
  onCancel: (clientTmpId: string) => void
  onDismiss: (clientTmpId: string) => void
  includeQueued?: boolean
}

/**
 * List of file upload/processing status items.
 * Only re-renders when the list of file IDs changes (items added/removed),
 * not when individual file contents change.
 * Newest items appear at the top.
 */
export function ProcessingStatusList({ onCancel, onDismiss, includeQueued = false }: ProcessingStatusListProps) {
  const fileIds = useAppSelector(includeQueued ? selectUploadDrawerFileIds : selectProcessingFileIds)

  if (fileIds.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-2">
      {fileIds.map((id) => (
        <ProcessingStatusItem key={id} clientTmpId={id} onCancel={onCancel} onDismiss={onDismiss} />
      ))}
    </div>
  )
}
